import reportLogic from 'src/logic/report';
import Router from 'next/router';

/**
 * logic目录的代码为生成的代码,report代码通过imove生成，可参考流程图
 * https://wtest.calendar.tencent.com/logic/activity?projectId=report
 */

export interface EventTask {
  eventName: string;
  reportObj: Partial<any>;
}

// 上报实例
let reportIns: any = null;
// 上报未初始化完成前收集已触发的上报任务，待初始化完成后取出执行
const cacheDataReportTask: EventTask[] = [];

/**
 * 数据上报初始化
 * @returns
 */
export const initDataReport = () => {
  if (reportIns) return reportIns;
  reportIns = 'loading';
  reportLogic.invoke(
    'initDataReport',
    {
      cacheDataReportTask,
    },
    (webReport: any) => {
      reportIns = webReport;
    },
  );
};

/**
 * 数据组数据上报，原先的灯塔上报逐步废弃，改用这个新的
 * @param eventName 事件id
 * @param reportObj 上报数据，注意reportObj 的value 类型只能是string 或者 number 类型
 */
const dataReport = (eventName = '', reportObj = {}) => {
  if (typeof window === 'undefined') return;
  reportLogic.invoke(
    'beaconReport',
    {
      eventCode: eventName,
      params: {
        activity_id: Router.router?.query?.eventid || '',
        host_id: window?.sessionStorage?.getItem('user:hostId') || '',
        ...reportObj,
      },
      reportIns,
    },
    (task: any) => {
      if (task) cacheDataReportTask.push(task);
    },
  );
};

export default dataReport;
